import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Holiday } from '../../common/interfaces/holiday';
import {
    CalendarEvent,
    InstructorEventTypes,
} from '../interfaces/resourceCalendarProps';
import { HOLIDAY_EVENT_COLOR } from '../constants';

dayjs.extend(utc);

export const HOLIDAY_TEXT = 'Holiday';

export const buildHolidayEventsForInstructor = (
    holidays: Array<Holiday>,
    instructorPk: string,
): Array<CalendarEvent> => {
    return holidays.map((holiday) => {
        // Get the date string in UTC (e.g. "2026-05-01") and treat it as a
        // local date so FullCalendar renders it on the correct calendar day
        // regardless of the browser's timezone.
        const dateStr = dayjs.unix(holiday.date).utc().format('YYYY-MM-DD');
        const start = dayjs(dateStr).startOf('day').valueOf();
        const end = dayjs(dateStr).endOf('day').valueOf();

        return {
            id: `holiday-${holiday.date}-${instructorPk}`,
            start,
            end,
            resourceId: instructorPk,
            backgroundColor: HOLIDAY_EVENT_COLOR,
            title: `${HOLIDAY_TEXT} - ${holiday.name}`,
            eventType: InstructorEventTypes.holiday,
        };
    });
};
